/***********************************************************/
/***********************************************************/
/* auctionModule Module */
/***********************************************************/
/***********************************************************/

var auctionModule = (function() {
  var url = '/auctions/v1/';
  var accountAuctionsUrl = '/account/v1/auctions/';
  var changeLeadingBidTimeoutIds = [];

  /*
    DESC: Get auction info. USED IN: homepage
  */
  function getFeaturedAuction(cb) {
    var req = new JsonRequest(servicesUrl + url + 'featured?locationId=' + getLocation(), {}, false, 'GET');

    req.success(function(res) {
      if (res.success) {
        if (res.result.length) {
          res.result = res.result.filter(function(item, idx) {
            return idx < 3;
          })
          $('.auction-list').html(tmpl($('#tmpl-home-auction-item').html(), {
            obj: res.result,
            currentAccountId: getAccountId()
          }));
          // $('.active-auction').show();
          refreshAuctions();
        } else {
          $('.active-auction').remove();
        }
      }
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function getAuction(id, successCb) {
    var req = new JsonRequest(servicesUrl + url + 'auctions/' + id, {}, false, 'GET');

    req.success(function(res) {
      'function' === typeof successCb && successCb(res);
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function getAuctions(auctionIds, successCb) {
    var req = new JsonRequest(servicesUrl + url + 'auctions?auctionIds=' + auctionIds, {}, false, 'GET');

    req.success(function(res) {
      'function' === typeof successCb && successCb(res);
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function getAuctionBids(id, successCallback) {
    var req = new JsonRequest(servicesUrl + url + 'auctions/' + id + '/bids', {
      currency: 'SGD'
    }, false, 'GET');

    req.success(function(res) {
      successCallback(res);
    });

    req.send();
  }

  function bidAuction(id, amount, autobid, successCallback) {
    var req = new JsonRequest(servicesUrl + url + 'auctions/' + id + '/bid', {
      amount: amount,
      autobid: autobid,
      machineId: getMachineId()
    }, true, 'POST');

    req.success(function(res) {
      successCallback(res);
      // fetch latest watchlisted list as item is being watchlisted on every successful bid
      loadWatchlist();
    });


    req.send();
  }

  function saveToWatchlist(id) {
    var req = new JsonRequest(servicesUrl + accountAuctionsUrl + 'watchlist/' + id, {}, false, 'POST');
    var $auctionEl = getAuctionElement(id);
    var auction = {
      id: $auctionEl.data('id'),
      title: $auctionEl.data('title'),
      imageUrl: $auctionEl.data('image-url'),
      latestBid: $auctionEl.data('latest-bid'),
      endDate: $auctionEl.data('end-date'),
      systemTime: $auctionEl.data('system-time'),
      bids: $auctionEl.data('bids'),
      bid: $auctionEl.find('input.bid').val(),
      latestBidderAccountId: $auctionEl.data('latest-bidder-account-id'),
      minimumBid: $auctionEl.data('minimum-bid')
    }

    req.success(function(res) {
      console.log(res)
      if (res.success) {
        if (alertWatchlistedAuctionDontShow()) {
          var popup = new PopupSavedWatchlist(auction);
          popup.render();
        }
        auctionModule.loadWatchlist();
      }
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function removeToWatchlist(id) {
    var req = new JsonRequest(servicesUrl + accountAuctionsUrl + 'watchlist/' + id, {}, false, 'DELETE');

    req.success(function(res) {
      console.log(res);
      if (res.success) {
        auctionModule.loadWatchlist();
      }
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function loadWatchlist() {
    var req = new JsonRequest(servicesUrl + accountAuctionsUrl + 'watchlist', {}, false, 'GET');
    req.success(function(res) {
      console.log(res);
      if (res.success) {
        localStorage.setItem('watchlisted-auction-ids', JSON.stringify(res.items));
        // refreshAuctions();
      }
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function getSettings(successCb) {
    var req = new JsonRequest(servicesUrl + accountAuctionsUrl + 'settings', {}, false, 'POST');

    req.success(function(res) {
      console.log(res);
      'function' === typeof successCb && successCb(res);
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function updateSettings(auctionSettings, successCb) {
    var req = new JsonRequest(servicesUrl + accountAuctionsUrl + 'settings', auctionSettings, false, 'PUT');

    req.success(function(res) {
      console.log(res)
      'function' === typeof successCb && successCb(res);
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function refreshAuctionItem(auction, showTransition = null) {
    var $auctionEl = getAuctionElement(auction.id);
    if ($auctionEl && $auctionEl.length > 0) {

      if (showTransition || (showTransition == null && auction.latestBidderAccountId !== null && $auctionEl.data('latest-bidder-account-id') != auction.latestBidderAccountId)) {
        var auctionTransitionItem = changeLeadingBidTimeoutIds.find(item => item.id === auction.id);
        if (auctionTransitionItem) {
          clearTimeout(auctionTransitionItem.timer);
          changeLeadingBidTimeoutIds = changeLeadingBidTimeoutIds.filter(item => item.id !== auction.id);
        }

        $auctionEl.removeClass('change-leading');

        // add 100ms delay to give browser enough time to process removal and addition of 'change-leading' class
        setTimeout(() => {
          $auctionEl.addClass('change-leading');
        }, 100);


        // add 5 seconds delay for showing the pulse animation
        var timerId = setTimeout(() => {
          $auctionEl.removeClass('change-leading');
        }, 5000);

        var timerItem = {
          id: auction.id,
          timer: timerId
        };
        changeLeadingBidTimeoutIds.push(timerItem);
      }

      // if (auction.bids > 0) {
      $auctionEl.data('bids', auction.bids);
      if (!$auctionEl.find('.bid').is(':focus')) {
        $auctionEl.find('.bid').val(Number(auction.minimumBid));
      }
      $auctionEl.find('.bid-count').html(auction.bids == 1 ? auction.bids + ' Bid' : auction.bids + ' Bids');
      $auctionEl.data('latest-bidder-account-id', auction.latestBidderAccountId);
      $auctionEl.data('latest-bid', auction.latestBidPrice);
      $auctionEl.data('minimum-bid', auction.minimumBid);
      $auctionEl.data('minimum-bid-price', auction.minimumBidPrice);
      $auctionEl.data('autobid', auction.autoBid);
      $auctionEl.data('maximum-autobid', auction.maximumAutobid);
      $auctionEl.data('maximum-autobid-price', auction.maximumAutobidPrice);
      $auctionEl.data('latest-autobidder-account-id', auction.latestAutoBidderAccountId);
      $auctionEl.data('increment', auction.increment);
      // }
      $auctionEl.data('end-date', auction.endDate);
      $auctionEl.data('system-time', auction.systemTime);
      $auctionEl.find('.price').html(auction.latestBidPrice);

      if (auction.directBuyEnabled) {
        $auctionEl.find('.btn-buy-now').removeClass('hide');
        $auctionEl.find('.btn-buy-now').html('Buy Now: ' + auction.directBuyPrice);
      } else {
        $auctionEl.find('.btn-buy-now').addClass('hide');
      }

      if (auction.autoBidders.includes(parseInt(getAccountId()))) {
        if (auction.latestBidderAccountId != getAccountId()) {
          $auctionEl.find('.autobid-reached').removeClass('invisible');
        } else if (auction.latestBidderAccountId == getAccountId() && !auction.autoBid) {
          $auctionEl.find('.autobid-reached').removeClass('invisible');
        } else {
          $auctionEl.find('.autobid-reached').addClass('invisible');
        }
      } else {
        $auctionEl.find('.autobid-reached').addClass('invisible');
      }
    }
  }

  function listAuctionsFilter(params, successCb, errorCb, alwaysCb) {
    var auctionRequestUrl = isMyAccountAuctionsPage() ? accountAuctionsUrl + 'filter?' : url + 'auctions/filter?';
    var req = new JsonRequest(servicesUrl + auctionRequestUrl + params, {}, false, 'POST');

    req.success(function(res) {
      console.log(res)
      res.success && successCb(res);
      if (typeof alwaysCb === 'function') alwaysCb();
    });

    req.error(function(res) {
      console.log(res)
      errorCb(res);
      if (typeof alwaysCb === 'function') alwaysCb();
    });

    req.send();
  }

  function getShippingFee() {
    var auctionId = $('.product-auction').data('id');
    var shippingCountry = $('.ship-to #country').val();
    var req = new JsonRequest(servicesUrl + url + 'auctions/shipping-estimation/' + auctionId + '?currency=' + getCurrency() + '&shippingCountry=' + shippingCountry, {}, false, 'GET');

    req.success(function(res) {
      if (res.success) {
        if (res.insurance && res.insurance.length) {
          $('.shipping-note').html('<strong>Shipping: ' + res.shipping + '<br>Insurance: ' + res.insuranceRate + ' of the auction price</strong> <br>(' + res.insurance + ' based on the current leading bid)');
        } else {
          $('.shipping-note').html('<strong>Shipping & Insurance: ' + res.shipping + '</strong>');
        }
      }
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function buyNow(id) {
    var data = {
      cartString: shoppingCartModule.getCartString(),
      locationId: getLocation(),
    }
    var req = new JsonRequest(servicesUrl + url + 'auctions/' + id + '/buy-now', data, false, 'POST');

    req.success(function(res) {
      if (res.success) {
        shoppingCartModule.updateCartString(res.cartString);
        shoppingCartModule.updateHeaderShoppingCartCount(res.cartEntries.length);

        if (res.title.length && res.message.length) {
          var options = {
            title: res.title,
            message: res.message,
            okCallback: function() {
              if (res.redirectUrl.length) {
                window.location.href = res.redirectUrl;
              }
              // else {
              //   var $auctionEl = getAuctionElement(id);
              //   if ($auctionEl && $auctionEl.length > 0) {
              //     $auctionEl.find('.btn-buy-now').addClass('hide');
              //   }
              // }
            }
          };

          var popup = new Popup(options);
          popup.render();
        } else if (res.redirectUrl.length) {
          window.location.href = res.redirectUrl;
        }
      }
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function initAuctionPage() {
    document.querySelector('.ship-to #country').addEventListener('change', function() {
      getShippingFee();
    });

    getShippingFee();
  }

  function initSocket() {
    console.log('init websocket');
    auctionWebSocketModule.addListener(websocketMessageArrived);
  }

  function websocketMessageArrived(message) {
    let showTransition = message.showTransition;
    if (message.latestBidderAccountId != getAccountId() && message.autoBid == true && message.outbidByAutoBid == false) {
      showTransition = false;
    }
    console.log('Got message from websocket module');
    console.log(message);
    refreshAuctionItem(message, showTransition);
  }


  return {
    getFeaturedAuction: getFeaturedAuction,
    listAuctionsFilter: listAuctionsFilter,
    getAuction: getAuction,
    getAuctions: getAuctions,
    getAuctionBids: getAuctionBids,
    bidAuction: bidAuction,
    saveToWatchlist: saveToWatchlist,
    removeToWatchlist: removeToWatchlist,
    loadWatchlist: loadWatchlist,
    refreshAuctionItem: refreshAuctionItem,
    getSettings: getSettings,
    getShippingFee: getShippingFee,
    initAuctionPage: initAuctionPage,
    updateSettings: updateSettings,
    initSocket: initSocket,
    buyNow: buyNow
  }

}());

/* Add for mocha testing */
// Basically it make the auctionModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = auctionModule;
}